<template>
    <div class="container">
      <div class="text-center" style="margin: 20px 0px 20px 0px">
        <span class="text-secondary"
          >USUARIO: {{ this.nombre }} {{ this.apellido }}</span
        >
      </div>
      <div class="row justify-content-center" style="margin: 20px 0px 20px 0px">
        <div class="col-md-12" align="center">
          <label>Territorio:</label>
          <select
            class="form-control"  v-model="territorio"  @change="getSectores()" >
            <option v-for="t in territorios" :value="t.id">{{ t.nombre }}</option>
          </select>
          <br />
        </div>
        <div class="col-md-4 bg-red" align="center">
          <label>No Permitidos</label>
          <select class="form-control" multiple size="5" v-model="sector_se" >
            <option v-for="ss in sectores_no_seleccionados" :value="ss.id">
              {{ ss.nombre }}
            </option>
          </select>
        </div>
        <div class="col-md-4" align="center">
          <div class="align-middle">
            <br /><br />
            <input
              type="button"
              v-on:click="this.asignar()"
              class="quitar btn btn-primary"
              value=" Asignar >>"
            /><br /><br />
            <input
              type="button"
              v-on:click="this.quitar()"
              class="pasar btn btn btn-danger"
              value=" << Retirar "
            /><br /><br />
          </div>
        </div>

        <div class="col-md-4 bg-green" align="center">
          <label>Permitidos</label>
          <select class="form-control" multiple size="5" v-model="sector_no"  >
            <option
              v-for="s in sectores_seleccionados"
              multiple
              size="5"
              :value="s.id"
            >
              {{ s.nombre }}
            </option>
          </select>
        </div>


      </div>
    </div>
  </template>



  <script>


  export default {
    props: ["usu", "tipoAccion"],
    data() {
      return {
        componentKey : 0,
        codigo: "",
        nombre: "",
        apellido: "",
        accion: 0,
        territorio: 0,
        territorios: [],
        sector_no: [],
        sector_se: [],
        sectores_seleccionados: [],
        sectores_no_seleccionados: [],


      };
    },

    methods: {
      getTerritorios: function () {
        axios.get("/user_sector_territorios/territorios_sector_usuario1").then(
          function (response) {
            this.territorios = response.data;
          }.bind(this)
        );
      },
      getSectores: function () {
                  console.log('entrando en getSectores');

                   axios.get("/user_sector_territorios/sector_usuario1/" +
              this.codigo +
              "/" +
              this.territorio +
              "/" +
              this.accion +"/"+ this.componentKey
          )
          .then(
            function (response) {
              this.sectores_seleccionados = response.data.sectores_seleccionados;
              this.sectores_no_seleccionados =response.data.sectores_no_seleccionados;



            }.bind(this)
          );
      },



        asignar: function () {

       axios.post("/user_sector_territorios/asignar_sector_usuario1", {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            codigo: this.codigo,
            territorio: this.territorio,
            accion: this.accion,
            operacion:1,
            sector_se:this.sector_se,

          })
          .then(

              response=>(this.sectores_seleccionados = response.data.sectores_seleccionados,this.sectores_no_seleccionados =response.data.sectores_no_seleccionados)


          )
          .catch(function (error) {
              console.log('uppps');
          })

      },

      quitar: function () {
       axios.post("/user_sector_territorios/asignar_sector_usuario1", {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            codigo: this.codigo,
            territorio: this.territorio,
            accion: this.accion,
            operacion:0,
            sector_se:this.sector_no,

          })
          .then(

              response=>(this.sectores_seleccionados = response.data.sectores_seleccionados,this.sectores_no_seleccionados =response.data.sectores_no_seleccionados)


          )
          .catch(function (error) {
              console.log('uppps');
          })
      },




    },

    mounted() {
      this.codigo = this.usu.codigo;
      this.nombre = this.usu.name;
      this.apellido = this.usu.apellido;
      this.accion = this.tipoAccion;
      this.getTerritorios();
    },
  };
  </script>
